import { FileText, Image as ImageIcon } from 'lucide-react'

import type { ChatAttachment } from '@/models/chat'

const IMAGE_EXT = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', '.png', '.jpg', '.jpeg', '.gif', '.webp'])

function formatSize(bytes: number): string {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

interface ChatAttachmentChipsProps {
  attachments: ChatAttachment[]
}

export function ChatAttachmentChips({ attachments }: ChatAttachmentChipsProps) {
  if (!attachments || attachments.length === 0) return null

  return (
    <div className="flex flex-wrap gap-1.5">
      {attachments.map((att) => {
        const isImage = IMAGE_EXT.has((att.fileExtension || '').toLowerCase())
        const Icon = isImage ? ImageIcon : FileText
        const body = (
          <span className="bg-background/70 hover:bg-background/90 text-ink inline-flex items-center gap-1.5 rounded-md border px-2 py-1 text-xs font-normal">
            <Icon className="size-3.5 shrink-0" />
            <span className="max-w-[14rem] truncate">{att.fileName}</span>
            {att.fileSize ? (
              <span className="text-muted-foreground text-[10px]">{formatSize(att.fileSize)}</span>
            ) : null}
          </span>
        )
        return att.fileUrl ? (
          <a
            key={att.attachmentId || att.documentId}
            href={att.fileUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {body}
          </a>
        ) : (
          <span key={att.attachmentId || att.documentId}>{body}</span>
        )
      })}
    </div>
  )
}
